// extracted by mini-css-extract-plugin
module.exports = {"main":"BannerSection_main__noQoy"};